/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilterList } from '@fortawesome/pro-solid-svg-icons';

// components
import { DateRangeSelect } from '../../common/components';
import { LoaderButton, Table } from '../../common/components';

// actions
import {
  getFileHistory,
  getFilePatterns,
  getFileDetails,
} from '../../actions/rts';
import { useOutsideClick } from '../../common/hooks';

function CarrierFilterSelect() {
  const dispatch = useDispatch();
  const { 
    carriers,
    rts: {
      patterns,
      filters: { carrierID },
    },
  } = useSelector(store => store);

  // create the list of available RTS carriers by finding the unique
  // carrier ids that exist in the file family patterns list
  const rtsCarrierIDs = [ ...(new Set(patterns.map(p => p.carrierID))) ].filter(cid => (typeof cid === 'number'));

  return (
    <>
      <div className="form-label">
        Carrier
      </div>
      <div className="input-group">
        <select
          className="form-select"
          value={carrierID}
          onChange={(e) => dispatch({
            type: 'SET_RTS_FILTER',
            payload: { carrierID: e.target.value ? e.target.value : undefined  },
          })}
        >
          <option value="">All</option>
          {rtsCarrierIDs.map(c => (
            <option value={c}>{carriers[c]}</option>
          ))}
        </select>
      </div>
    </>
  );
}

function FamilyIDFilter() {
  const dispatch = useDispatch();
  const { familyID } = useSelector(store => store.rts.filters);

  return (
    <>
      <div className="form-label">
        File Family ID
      </div>
      <div className="input-group">
        <button
          className="btn btn-outline-secondary"
          onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'patternsModal' })}
        >
          <FontAwesomeIcon icon={faFilterList} />
        </button>
        <input
          className="form-control"
          value={familyID || ''}
          onChange={(e) => dispatch({ type: 'SET_RTS_FILTER', payload: { familyID: e.target.value } })}
          disabled
        />
        <button
          className="btn btn-outline-danger"
          onClick={() => dispatch({ type: 'SET_RTS_FILTER', payload: { familyID: undefined } })}
        >
          x
        </button>
      </div>
    </>
  );
}

function History() {
  const dispatch = useDispatch();
  const [ loading, setLoading ] = useState(false);
  const [ initialLoad, setInitialLoad ] = useState(false);
  const {
    filters,
    history,
    filters: {
      startDate,
      endDate,
    },
  } = useSelector(store => store.rts);
  const {
    carriers,
    theme: { rtsCarrierIDs = [] },
  } = useSelector(store => store);

  function loadHistory() {
    dispatch({ type: 'SET_RTS_FILE_HISTORY', history: [] });
    setLoading(true);
    getFileHistory(filters)
      .then((history) => {
        dispatch({ type: 'SET_RTS_FILE_HISTORY', history });
      }).finally(() => setLoading(false));
  }

  function formatCarrierID(cid) { return carriers[cid]; }
  function formatProcessingDate(pdate) { return moment(pdate).format('MM/DD/YYYY HH:mm A'); }
  function formatActivationNumber(data) {
    return (
      <button
        onClick={() => {
          dispatch({
            type: 'SET_RTS_FIELD',
            payload: {
              selectedFile: data,
              detailsListType: 'activations',
            },
          });
          dispatch({ type: 'OPEN_MODAL', modal: 'rtsDetailsModal' });
        }}
        type="button"
        className="btn btn-link"
      >
        {data.newAgentsCount}
      </button>
    );
  }
  function formatDeactivationNumber(data) {
    return (
      <button
        onClick={() => {
          dispatch({
            type: 'SET_RTS_FIELD',
            payload: {
              selectedFile: data,
              detailsListType: 'deactivations',
            },
          });
          dispatch({ type: 'OPEN_MODAL', modal: 'rtsDetailsModal' });
        }}
        type="button"
        className="btn btn-link"
      >
        {data.deactivatedAgentsCount}
      </button>
    );
  }

  useEffect(() => {
    // load only once the initial startDate is set in redux
    if (!initialLoad && startDate) {
      setInitialLoad(true);
      setLoading(true);
      loadHistory();
      getFilePatterns()
        .then((patterns) => dispatch({ type: 'SET_RTS_PATTERNS', patterns }));
    }
  }, [startDate]);

  return (
    <div>
      <div className="row justify-content-between">

        <div className="col-3">
          <div className="form-label">
            Processing Date
          </div>
          <DateRangeSelect
            startSetter={(sd) => dispatch({ type: 'SET_RTS_FILTER', payload: { startDate: sd } })}
            endSetter={(ed) => dispatch({ type: 'SET_RTS_FILTER', payload: { endDate: ed } })}
            startDate={startDate}
            endDate={endDate}
          />
        </div>

        <div className="col-3">
          <CarrierFilterSelect />
        </div>

        <div className="col-2">
          <FamilyIDFilter />
        </div>

        <div className="d-flex col-auto align-items-end ms-auto me-3">
          <LoaderButton
            className="btn btn-primary"
            onClick={loadHistory}
            text="Filter"
            loadingText="Filtering"
            loading={loading}
          />
        </div>

      </div> {/* end row */}

      <hr className="mt-4" />

      <div className="row mt-4 px-2">
        <Table
          className="table table-bordered"
          schema={{
            cols: [
              { header: 'Plan Year', field: 'planYear' },
              { header: 'RTS File Family ID', field: 'familyID' },
              { header: 'Carrier', field: 'carrierID', formatter: formatCarrierID },
              { header: 'File Name', field: 'fileName' },
              { header: 'Processing Date', field: 'processingDate', formatter: formatProcessingDate },
              { header: 'Total Records in File', field: 'totalAgentsCount' },
              { header: 'New Agents', passAllData: true, formatter: formatActivationNumber },
              { header: 'Updated Agents', field: 'updatedAgentsCount' },
              { header: 'Deactivated Agents', passAllData: true, formatter: formatDeactivationNumber },
            ],
          }}
          data={history}
          loading={loading}
        />
      </div> {/* end row */}

    </div>
  );
}

export default History;
